import React from 'react';
import { connect } from 'react-redux';
import { NavLink } from 'react-router-dom';
import { reduxForm, Field } from 'redux-form';
import { Grid } from './../../../themes/default';
import { Tabs, Tab } from './../../../themes/tab';
import { Section, Content, Main, Buttons, FormContent, FormActions, TabHead, TabContent } from './../../../components/includes/container';
import { Loading } from './../../../components/includes/loading';
import { ToolbarPrimary } from './../../../components/includes/toolbar';
import { BreadcrumbItem } from './../../../components/includes/breadcrumb';
import { Modal } from './../../../components/includes/modal';
import { Table, Thead, Tbody, Row, Cell, Tresponsive, Ttolbar } from './../../../components/includes/ui/table';
import { InputTextField, SelectField, OptionField } from './../../../components/includes/ui/input';
import { Btn, RichTextMarkdown } from './../../../components/includes/ui';
import { ProductService } from './../../../services';
import { isSorting } from './../../../utilities/utils';
import { FormatCurrency } from './../../../utilities/currency';
import VALIDATION from './../../../config/validation';

// @Rows Prizes
const rowsPrizes = [
  { id: 'branch', sort: true, numeric: false, disablePadding: false, label: 'Ramo' },
  { id: 'moduleOne', sort: true, numeric: false, disablePadding: false, label: 'Módulo 1' },
  { id: 'moduleTwo', sort: true, numeric: false, disablePadding: false, label: 'Módulo 2' },
  { id: 'moduleThree', sort: true, numeric: false, disablePadding: false, label: 'Módulo 3' },
  { id: 'plan', sort: true, numeric: false, disablePadding: false, label: 'Plan' },
  { id: 'prize', sort: true, numeric: false, disablePadding: false, label: 'Premio' },
  { id: 'product', sort: true, numeric: false, disablePadding: false, label: 'Producto' }
];

// @Rows SumsCovered
const rowsSums = [
  { id: 'custom.visible', sort: false, numeric: false, disablePadding: false, label: 'Visible' },
  { id: 'name', sort: true, numeric: false, disablePadding: false, label: 'Nombre' },
  { id: 'branch', sort: true, numeric: false, disablePadding: false, label: 'Ramo' },
  { id: 'coverage', sort: true, numeric: false, disablePadding: false, label: 'Covertura' },
  { id: 'module', sort: true, numeric: false, disablePadding: false, label: 'Módulo' },
  { id: 'plan', sort: true, numeric: false, disablePadding: false, label: 'Plan' },
  { id: 'segment', sort: true, numeric: false, disablePadding: false, label: 'Segmento' },
  { id: 'sum', sort: true, numeric: false, disablePadding: false, label: 'Suma' },
  { id: 'product', sort: true, numeric: false, disablePadding: false, label: 'Producto' }
];

const validate = values => {

  const errors = {}

  if (!values.name) {
    errors.name = VALIDATION.required;
  }else if(values.name.length > 2048){
    errors.name = VALIDATION.maxlength;
  }

  if (!values.title) {
    errors.title = VALIDATION.required;
  }else if(values.title.length > 2048){
    errors.title = VALIDATION.maxlength;
  }

  if (values.subtitle) {
    if(values.subtitle.length > 2048){
      errors.subtitle = VALIDATION.maxlength;
    }
  }

  if (values.status === '-1') {
    errors.status = VALIDATION.required;
  }

  // if (!values.addons || !values.addons.length) {
  //
  //   errors.addons = { _error: 'At least one member must be entered' }
  //
  // } else {


    if (values.addons) {

      const addonsArrayErrors = [];

      values.addons.forEach((addon, index) => {

        const addonsErrors = {};

        if (!addon || !addon.name) {
          addonsErrors.name = VALIDATION.required;
          addonsArrayErrors[index] = addonsErrors;
        }

        if (!addon || !addon.price) {
          addonsErrors.price = VALIDATION.required;
          addonsArrayErrors[index] = addonsErrors;
        }

        if (!addon || !addon.position) {
          addonsErrors.position = VALIDATION.required;
          addonsArrayErrors[index] = addonsErrors;
        }

      })

      if (addonsArrayErrors.length) {
        errors.addons = addonsArrayErrors
      }

    }

  //}

  return errors

};

class ProductUpdate extends React.Component {

  constructor(props){
    super(props);
    this.state = {
      id: null,
      loading: false,
      sending: false,
      product: null,
      tabActive: 0,
      expandedActive: null,
      orderSums: 'asc',
      orderSumsBy: 'segment',
      orderPrices: 'asc',
      orderPricesBy: 'plan',
      statusCoverages: false,
      statusCoveragesText: null
    };
  }

  componentDidMount(){

    this._Find(this.props.match.params.id);

  }

  /*
  ** @Service
  ** @Description: Find
  */

  _Find = (id) => {

    ProductService.find(id).then((response) => {

      // @State
      this.setState({ loading: true, id: id, product: response.product });

      // @Dispatch
      this.props.Update(response);

    }).catch((error) => {

      // @Dispatch alert error
      this.props.AlertShow({ open: true, variant: 'error', message: error });

    });

  }

  /*
  ** @Service
  ** @Description: Update
  */

  _Update = (values) => {

    // @Loading
    this.setState({ loading: false, sending: true });

    // @Service
    ProductService.update(this.state.id, values).then((response) => {

      /**
      * @Service find all by page
      */
      this.props.history.push('/products');

      /**
      * @Dispatch for alert success message
      */
      this.props.AlertShow({ open: true, variant: 'success', message: `Exito, el producto fue editado.` });

    }).catch((error) => {

      /**
      * @State
      */
      this.setState({ sending: false });

      // @Dispatch alert error
      this.props.AlertShow({ open: true, variant: 'error', message: error.data.message });

    });

  }

  /*
  ** @Event
  ** @Description: Submit button
  */

  handleSubmitForm = (values) => {
    this._Update(values);
  }

  /*
  ** @Event
  ** @Description: Change tabs content
  */

  handleChange = (event, tabActive) => {
    this.setState({ tabActive });
  };

  /*
  ** @Handle
  ** @Description: Short order
  */

  handleRequestSortSums = (event, property) => {

    const orderSumsBy = property;
    let orderSums = 'desc';

    if (this.state.orderSumsBy === property && this.state.orderSums === 'desc') {
      orderSums = 'asc';
    }

    this.setState({ orderSums, orderSumsBy });

  };

  /*
  ** @Handle
  ** @Description: Short order
  */

  handleRequestSortPrices = (event, property) => {

    const orderPricesBy = property;
    let orderPrices = 'desc';

    if (this.state.orderPricesBy === property && this.state.orderPrices === 'desc') {
      orderPrices = 'asc';
    }

    this.setState({ orderPrices, orderPricesBy });

  };

  /*
  ** @Event
  ** @Description: Toggle Panels
  */

  handleToggle = panel => (event, expanded) => {
    this.setState({
      expandedActive: expanded ? panel : false
    });
  };

  /*
  ** @Event
  ** @Description: Submit button
  */

  handleShowCoverage = (values) => {

    this.handleCoverages(true);

    // @Description: set description coverage
    this.setState({ statusCoveragesText: values.description });

  }

  /*
  ** @Event
  ** @Description: Toggle coverages
  */

  handleCoverages = (status) => {
    this.setState({ statusCoverages: status });
  }

  render() {

    const { loading, sending, product, tabActive, orderSums, orderSumsBy, orderPrices, orderPricesBy, statusCoverages, statusCoveragesText } = this.state;
    const { handleSubmit, invalid } = this.props;

    return (
      <Section>
        <ToolbarPrimary title="Productos"/>
        <BreadcrumbItem to='/products'>Productos</BreadcrumbItem>
        <BreadcrumbItem to='/products/update'>Editar</BreadcrumbItem>
        <Content>

          <Main>

            { loading ? (

              <React.Fragment>

                <Ttolbar title={ `${ product.name }` }/>

                <form noValidate autoComplete="off" onSubmit={ handleSubmit(this.handleSubmitForm) }>

                  <FormContent disabledGutterTop>

                    <TabHead>
                      <Tabs
                        value={ tabActive }
                        onChange={ this.handleChange }
                        variant="fullWidth"
                      >
                        <Tab label="Información" />
                        <Tab label="Sumas Aseguradas" />
                        <Tab label="Premios" />
                        <Tab label="Términos y Condiciones" />
                      </Tabs>
                    </TabHead>

                    {tabActive === 0 &&
                      <TabContent>

                        <FormContent enabledActions disabledGuttersSide>

                          <Grid container spacing={24}>

                            <Grid item lg={6} md={6} sm={12} xs={12}>
                              <Field
                                  name="name"
                                  component={ InputTextField }
                                  label="Nombre"
                                  type="text"
                                  required
                                  disabled={ true }
                              />
                            </Grid>

                            <Grid item lg={6} md={6} sm={12} xs={12}>
                              <Field
                                  name="status"
                                  component={ SelectField }
                                  label="Estado" required>
                                    <OptionField key="-1" value="-1">Seleccionar...</OptionField>
                                    <OptionField key="true" value="true">Activo</OptionField>
                                    <OptionField key="false" value="false">Bloqueado</OptionField>
                              </Field>
                            </Grid>

                            <Grid item lg={6} md={6} sm={12} xs={12}>
                              <Field
                                  name="title"
                                  component={ InputTextField }
                                  label="Título"
                                  type="text"
                                  required
                              />
                            </Grid>

                            <Grid item lg={6} md={6} sm={12} xs={12}>
                              <Field
                                  name="subtitle"
                                  component={ InputTextField }
                                  label="Sub-Titulo"
                                  type="text"
                              />
                            </Grid>

                            <Grid item lg={12} md={12} sm={12} xs={12}>
                              <Field
                                  name="thanks"
                                  component={ InputTextField }
                                  label="Texto para página de confirmación"
                                  type="text"
                              />
                            </Grid>

                            <Grid item lg={3} md={3} sm={6} xs={12}>
                              <Field
                                  name="price"
                                  component={ InputTextField }
                                  label="Precio"
                                  type="number"
                                  required
                                  disabled={ true }
                              />
                            </Grid>

                            <Grid item lg={3} md={3} sm={6} xs={12}>
                              <Field
                                  name="sf_code"
                                  component={ InputTextField }
                                  label="Código"
                                  type="text"
                                  disabled={ true }
                              />
                            </Grid>

                            <Grid item lg={3} md={3} sm={6} xs={12}>
                              <Field
                                  name="sf_branch"
                                  component={ InputTextField }
                                  label="Ramo"
                                  type="text"
                                  disabled={ true }
                              />
                            </Grid>

                            <Grid item lg={3} md={3} sm={6} xs={12}>
                              <Field
                                  name="sf_plan"
                                  component={ InputTextField }
                                  label="Plan"
                                  type="text"
                                  disabled={ true }
                              />
                            </Grid>

                          </Grid>

                        </FormContent>

                      </TabContent>
                    }

                    {tabActive === 1 &&
                      <TabContent>
                        <FormContent enabledActions disabledGuttersSide>
                          <Tresponsive>
                            <Table>
                              <Thead rows={ rowsSums } order={ orderSums } orderBy={ orderSumsBy } onRequestSort={ this.handleRequestSortSums }/>
                              <Tbody>

                                { product.sums.length > 0 ? (

                                   product.sums.sort(isSorting(orderSums, orderSumsBy)).map(entity => {
                                    return (
                                      <Row key={ entity._id }>
                                        <Cell>
                                          { entity.custom.visible ? 'SI' : 'NO' }
                                        </Cell>
                                        <Cell>
                                          { entity.name }
                                        </Cell>
                                        <Cell>
                                          { entity.branch }
                                        </Cell>
                                        <Cell>
                                          <Btn color="success" onClick={ () => { this.handleShowCoverage(entity.custom) } }>
                                            { entity.coverage }
                                          </Btn>
                                        </Cell>
                                        <Cell>
                                          { entity.module }
                                        </Cell>
                                        <Cell>
                                          { entity.plan }
                                        </Cell>
                                        <Cell>
                                          { entity.segment }
                                        </Cell>
                                        <Cell>
                                          <FormatCurrency value={ entity.sum }/>
                                        </Cell>
                                        <Cell>
                                          { entity.product }
                                        </Cell>
                                      </Row>
                                    );
                                  })

                                ) : (

                                  <Row key="1">
                                    <Cell colSpan={ rowsSums.length }>No se encontraron resultados.</Cell>
                                  </Row>

                                )}

                              </Tbody>
                            </Table>
                          </Tresponsive>
                        </FormContent>
                      </TabContent>
                    }

                    {tabActive === 2 &&
                      <TabContent>
                        <FormContent enabledActions disabledGuttersSide>
                          <Tresponsive>
                            <Table>
                              <Thead rows={ rowsPrizes } order={ orderPrices } orderBy={ orderPricesBy } onRequestSort={ this.handleRequestSortPrices }/>
                              <Tbody>

                                { product.prizes.length > 0 ? (

                                   product.prizes.sort(isSorting(orderPrices, orderPricesBy)).map(entity => {
                                    return (
                                      <Row key={ entity._id }>
                                        <Cell>
                                          { entity.branch }
                                        </Cell>
                                        <Cell>
                                          { entity.moduleOne }
                                        </Cell>
                                        <Cell>
                                          { entity.moduleTwo }
                                        </Cell>
                                        <Cell>
                                          { entity.moduleThree }
                                        </Cell>
                                        <Cell>
                                          { entity.plan }
                                        </Cell>
                                        <Cell>
                                          <FormatCurrency value={ entity.prize }/>
                                        </Cell>
                                        <Cell>
                                          { entity.product }
                                        </Cell>
                                      </Row>
                                    );
                                  })

                                ) : (

                                  <Row key="1">
                                    <Cell colSpan={ rowsPrizes.length }>No se encontraron resultados.</Cell>
                                  </Row>

                                )}

                              </Tbody>
                            </Table>
                          </Tresponsive>
                        </FormContent>
                      </TabContent>
                    }

                    {tabActive === 3 &&
                      <TabContent>

                        <FormContent enabledActions disabledGuttersSide>

                          <Grid container spacing={24}>

                            <Grid item lg={12} md={12} sm={12} xs={12}>
                              <Field
                                  name="terms"
                                  component={ RichTextMarkdown }
                                  label="Términos y Condiciones"
                                  type="text"
                                  required
                              />
                            </Grid>
                          </Grid>

                        </FormContent>

                      </TabContent>
                    }

                  </FormContent>

                  <FormActions>
                    <Grid container>
                      <Grid item lg={6} md={6} sm={12}>
                        <Buttons>
                          <Btn aria-label="Volver" icon="back" color="secondary" component={ NavLink } to="/products">
                            Volver
                          </Btn>
                        </Buttons>
                      </Grid>
                      <Grid item lg={6} md={6} sm={12}>
                        <Buttons align="right">
                          <Btn aria-label="Guardar" icon="add" color="success" type="submit" disabled={ invalid } loading={ sending }>
                            Guardar producto
                          </Btn>
                        </Buttons>
                      </Grid>
                    </Grid>
                  </FormActions>

                </form>

                <Modal
                    status={ statusCoverages }
                    title={ `Detalle de cobertura` }
                    handleCancel={ () => { this.handleCoverages(false) } }
                    maxWidth="md">
                    <div dangerouslySetInnerHTML={{ __html: statusCoveragesText }}/>
                </Modal>

              </React.Fragment>

            ) : (
              <Loading variant="primary"/>
            )}

          </Main>

        </Content>
      </Section>
    )
  }

}

ProductUpdate = reduxForm({
  form: 'ProductUpdate',
  validate,
  enableReinitialize: true
})(ProductUpdate);

const mapStateToProps = (state) => {
  return {
    Alert: state.Alert,
    ProductUpdate: state.ProductUpdate
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    AlertShow: (data) => {
      dispatch({
        type: 'ALERT_SHOW',
        data: data
      });
    },
    Update: (data) => {
      dispatch({
        type: 'PRODUCT_UPDATE',
        data: data
      });
    }
  }
}

ProductUpdate = connect(
  state => ({
    initialValues: {
      name: state.ProductUpdate.name,
      status: String(state.ProductUpdate.status),
      title: state.ProductUpdate.title,
      subtitle: state.ProductUpdate.subtitle,
      thanks: state.ProductUpdate.thanks,
      price: state.ProductUpdate.price,
      terms: state.ProductUpdate.terms,
      addons: state.ProductUpdate.addons,
      sf_code: state.ProductUpdate.sf_code,
      sf_branch: state.ProductUpdate.sf_branch,
      sf_plan: state.ProductUpdate.sf_plan,
    }
  })
)(ProductUpdate);

export default connect(mapStateToProps, mapDispatchToProps)(ProductUpdate);
